import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./lib/auth";

// Layout
import { MainLayout } from "./components/layout/MainLayout";

// Public Pages
import { HomePage } from "./pages/HomePage";
import { GironiPage } from "./pages/GironiPage";
import CalendarioPage from "./pages/CalendarioPage";
import { SponsorPage } from "./pages/SponsorPage";
import { CapocannonierePage } from "./pages/CapocannonierePage";
import { MenuPage } from "./pages/MenuPage";
import { AlboDoroPage } from "./pages/AlboDoroPage";
import { GalleriaPage } from "./pages/GalleriaPage";
import { TabellonePage } from "./pages/TabellonePage";

// Admin Pages
import { AdminLoginPage } from "./pages/admin/AdminLoginPage";
import { AdminLayout } from "./pages/admin/AdminLayout";
import { AdminDashboardPage } from "./pages/admin/AdminDashboardPage";
import { AdminSquadrePage } from "./pages/admin/AdminSquadrePage";
import { AdminSorteggio } from "./pages/admin/AdminSorteggio";
import { AdminPartitePage } from "./pages/admin/AdminPartitePage";
import { AdminGiocatoriPage } from "./pages/admin/AdminGiocatoriPage";
import { AdminMenuPage } from "./pages/admin/AdminMenuPage";
import { AdminImpostazioniPage } from "./pages/admin/AdminImpostazioniPage";
import { AdminEliminatoriePage } from "./pages/admin/AdminEliminatoriePage";
import { AdminLogoPage } from "./pages/admin/AdminLogoPage";
import { AdminTabellonePage } from "./pages/admin/AdminTabellonePage";
import { AdminSponsorPage } from "./pages/admin/AdminSponsorPage";
import { AdminAlboDoroPage } from "./pages/admin/AdminAlboDoroPage";
import { AdminGalleriaPage } from "./pages/admin/AdminGalleriaPage";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

// Solo admin pieno (blocca operatori)
const AdminOnlyRoute = ({ children }) => {
  const { user } = useAuth();
  if (user && user.role !== 'admin') {
    return <Navigate to="/admin" replace />;
  }
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
          <Route path="/gironi" element={<MainLayout><GironiPage /></MainLayout>} />
          <Route path="/calendario" element={<MainLayout><CalendarioPage /></MainLayout>} />
          <Route path="/tabellone" element={<MainLayout><TabellonePage /></MainLayout>} />
          <Route path="/sponsor" element={<MainLayout><SponsorPage /></MainLayout>} />
          <Route path="/menu" element={<MainLayout><MenuPage /></MainLayout>} />
          <Route path="/albo-doro" element={<MainLayout><AlboDoroPage /></MainLayout>} />
          <Route path="/galleria" element={<MainLayout><GalleriaPage /></MainLayout>} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboardPage />} />
            <Route path="squadre" element={<AdminOnlyRoute><AdminSquadrePage /></AdminOnlyRoute>} />
            <Route path="sorteggio" element={<AdminOnlyRoute><AdminSorteggio /></AdminOnlyRoute>} />
            <Route path="partite" element={<AdminPartitePage />} />
            <Route path="giocatori" element={<AdminGiocatoriPage />} />
            <Route path="sponsor" element={<AdminOnlyRoute><AdminSponsorPage /></AdminOnlyRoute>} />
            <Route path="menu" element={<AdminOnlyRoute><AdminMenuPage /></AdminOnlyRoute>} />
            <Route path="impostazioni" element={<AdminOnlyRoute><AdminImpostazioniPage /></AdminOnlyRoute>} />
            <Route path="eliminatorie" element={<AdminEliminatoriePage />} />
            <Route path="capocannoniere" element={<CapocannonierePage />} />
            <Route path="tabellone" element={<AdminTabellonePage />} />
            <Route path="logo" element={<AdminOnlyRoute><AdminLogoPage /></AdminOnlyRoute>} />
            <Route path="albo-doro" element={<AdminAlboDoroPage />} />
            <Route path="galleria" element={<AdminGalleriaPage />} />
          </Route>
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors offset={20} />
    </AuthProvider>
  );
}

export default App;
